export default "__VITE_ASSET__BEstOROe__"